// extracted by mini-css-extract-plugin
export default {"wrapper":"KQm0Dh5","title":"CVpoQB5","subtitle":"jGn5f3V","list":"N9ekWFZ"};